@use "variables" as *;

.toolbar {
  background-color: #0e0e10;
  height: 40px;
  min-height: 0 !important;
}

.title {
  padding-left: $spacing-l;
}
